module.exports = __webpack_public_path__ + "static/img/gc_eyes.b1b49c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_eyes.png
// module id = 303
// module chunks = 1